import { render, staticRenderFns } from "./SectionButtons.vue?vue&type=template&id=993ccc4e"
import script from "./SectionButtons.vue?vue&type=script&lang=ts"
export * from "./SectionButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports